import { render, staticRenderFns } from "./BaseFrontOfficeSelect.vue?vue&type=template&id=363a7566&scoped=true"
import script from "./BaseFrontOfficeSelect.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeSelect.vue?vue&type=style&index=0&id=363a7566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a7566",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
